// extracted by mini-css-extract-plugin
export default {"panel-view-flag":"RelationalFlags_panel-view-flag__zQx+r","chip":"RelationalFlags_chip__4YYLR","label":"RelationalFlags_label__RoLAT"};